<template>
  <div data-bs-theme>
    <nav
      :class="isExpanded ? '' : 'navbar-vertical-sm'"
      class="navbar navbar-vertical fixed-start navbar-expand-md navbar-light ms-nav"
    >
      <div class="container main-sidebar">
        <div>
          <!-- Logo -->
          <a class="navbar-brand ms-brand" :class="isExpanded ? '' : 'mt-5'" href="/">
            <img
              v-if="isExpanded"
              src="../../assets/img/NKT MakeSense_Logo_for screen.png"
              class="ms-bar-logo mx-auto"
              alt="..."
            />

            <div v-else>
              <img src="../../assets/img/logo-vertical.svg" class="ms-bar-logo-small" alt="..." />
            </div>
          </a>

          <!-- User Type (e.g. Admin) -->
          <a
            v-if="userStore.isAdminOrHigher"
            class="navbar-brand py-2 px-3 mx-auto ms-nav-user-icon NKT-P2"
            href="#!"
          >
            {{ userStore.isMasterAdmin ? 'Master Admin' : 'Admin' }}
          </a>

          <!-- Expand/Minimize -->
          <div class="text-center" :class="isExpanded ? 'mt-4' : 'mt-5'">
            <MsButton
              @click="toggle"
              data-toggle="collapse"
              data-target="#content"
              button-custom-style="ms-expand-button"
            >
              <img :src="arrow" :class="{ rotated: !isExpanded }" class="icon" />
            </MsButton>
          </div>
        </div>

        <div></div>

        <div class="p-3">
          <!-- Nav-Items -->
          <ul class="navbar-nav">
            <NavigationItem
              :is-expanded="isExpanded ? isExpandedDebounced : isExpanded"
              :name="'Home'"
              href="/"
            />
            <NavigationItem
              :disabled="projectStore.selectedProject?.alarmLogsDisabled"
              :is-expanded="isExpanded ? isExpandedDebounced : isExpanded"
              :name="'Alarm Log'"
              href="/alarms"
            />
            <NavigationItem
              :is-expanded="isExpanded ? isExpandedDebounced : isExpanded"
              :name="'Electrical Performance'"
              :coming-soon="true"
              :disabled="true"
              href="/performance"
            />
            <NavigationItem
              :is-expanded="isExpanded ? isExpandedDebounced : isExpanded"
              :name="'Mechanical & Physical Data'"
              :disabled="projectStore.selectedProject?.mechanicalPhysicalDisabled"
              href="/mechanical"
            />
            <NavigationItem
              :disabled="projectStore.selectedProject?.marineSurveyDataDisabled"
              :is-expanded="isExpanded ? isExpandedDebounced : isExpanded"
              :name="'Marine Survey Data'"
              href="/survey"
            />
            <NavigationItem
              :disabled="projectStore.selectedProject?.sparePartsDisabled"
              :is-expanded="isExpanded ? isExpandedDebounced : isExpanded"
              :name="'Spare Parts'"
              href="/spareparts"
            />
            <NavigationItem
              :is-expanded="isExpanded ? isExpandedDebounced : isExpanded"
              :disabled="projectStore.selectedProject?.documentationDisabled"
              :name="'Documentation'"
              href="/documentation"
            />
            <NestedNavItem
              :is-expanded="isExpanded ? isExpandedDebounced : isExpanded"
              :name="'Administration'"
              href="/administration"
              @expand="toggle"
            />
          </ul>
        </div>
      </div>
    </nav>
  </div>
</template>

<script setup lang="ts">
import NavigationItem from './NavItem.vue'
import { onMounted, ref } from 'vue'
import arrow from '@/assets/svg/nav-arrow.svg'
import MsButton from '../general/buttons/MsButton.vue'
import { useUserStore } from '@/stores/UserStore'
import NestedNavItem from './NestedNavItem.vue'
import { useProjectStore } from '@/stores/ProjectStore'
import { watchDebounced } from '@vueuse/core'

const isExpanded = ref(true)
const isExpandedDebounced = ref(isExpanded.value)

var userStore = useUserStore()
const projectStore = useProjectStore()

function toggle() {
  isExpanded.value = !isExpanded.value
}

onMounted(() => {
  isExpandedDebounced.value = isExpanded.value
})

watchDebounced(
  isExpanded,
  (newVal) => {
    isExpandedDebounced.value = newVal
  },
  { debounce: 100 }
)
</script>

<style scoped>
.ms-bar-logo {
  margin-top: 32px;
  padding-left: 16px;
  padding-right: 16px;
  margin-bottom: 16px;
}

.ms-bar-logo-small {
  margin-top: 8px;
}

.ms-brand {
  margin-top: 20px;
}

.ms-nav-user-icon {
  background: var(--color-components-label-tag-selected, #c8f6c8);
  max-width: 120px;
  white-space: normal;
}

.ms-nav {
  transition: max-width 0.3s ease;
  box-shadow: 0px 0px 0.5px 0px rgba(66, 71, 76, 0.32), 0px 4px 8px 0px rgba(66, 71, 76, 0.05);
}

.navbar-vertical-sm.navbar-expand-md .navbar-brand-img {
  max-height: 2.5rem;
}

.navbar-vertical.navbar-expand-md .navbar-brand-img {
  max-height: 2.5rem;
}

.ms-expand-button {
  border-radius: var(--border-radius-small-tryout, 4px);
  background: var(--color-neutrals-lighter-grey, #f5f5f5);
}
</style>
